/**
 * @file fields.ts
 *
 * @description Import all defined fields
 */
import "./base";
import "./bool";
import "./datetime";
import "./phone";
import "./name";
import "./date";
import "./link";
import "./text";
import "./email";
import "./address";
import "./id";
import "./enum";
import "./multienum";
import "./file";
import "./currency";
import "./radio";
import "./relate";
import "./parent";
import "./facelift";
import "./name";
import "./function";
import "./password";
